define('controllers/fieldHcaptcha',[], function() {
    
    var controller = Marionette.Object.extend({

        initialize: function () {
            
            this.listenTo( nfRadio.channel( 'hcaptcha' ), 'init:model',      this.initHcaptcha  );
            this.listenTo( nfRadio.channel( 'forms' ),     'submit:response', this.resetHcaptcha );
            
            // Setup hCaptcha global functions and event bindings
            this.setupHcaptchaGlobals();
            this.bindHcaptchaEvents();
        },

       	initHcaptcha: function ( model ) {
       		nfRadio.channel( 'hcaptcha' ).reply( 'update:response', this.updateResponse, this, model.id );
        },

        updateResponse: function( response, fieldID ) {
        	var model = nfRadio.channel( 'fields' ).request( 'get:field', fieldID );
			model.set( 'value', response );
            nfRadio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'required-error' );
        },

        resetHcaptcha: function() {
			var hcaptchaID = 0;
			jQuery( '.h-captcha, .nf-h-captcha' ).each( function() {
				try {
					hcaptcha.reset( hcaptchaID );
				} catch( e ){
					// Silent fail
				}
				hcaptchaID++;
			} );
        },

        setupHcaptchaGlobals: function() {
            var self = this;
            
            // Setup global callback function
            window.nfHcaptchaCallback = function(token) {
                var completedWidget = null;
                jQuery(".h-captcha, .nf-h-captcha").each(function() {
                    if (this.querySelector("iframe")) {
                        completedWidget = this;
                        return false;
                    }
                });

                if (completedWidget && token) {
                    var fieldID = jQuery(completedWidget).data("fieldid");
                    var input = document.getElementById("nf-field-" + fieldID);
                    if (input) {
                        input.value = token;
                        jQuery(input).trigger("change");
                        jQuery(input).closest(".field-wrap").removeClass("nf-error");
                        jQuery(input).closest(".field-wrap").find(".nf-error-msg").remove();
                    }

                    if (typeof nfRadio !== "undefined" && nfRadio.channel) {
                        try {
                            nfRadio.channel("hcaptcha").request("update:response", token, fieldID);
                        } catch(e) {}
                    }
                }
            };

            // Setup global render function
            window.nfRenderHcaptcha = function() {
                
                if (typeof hcaptcha === "undefined") {
                    setTimeout(window.nfRenderHcaptcha, 100);
                    return;
                }

                var allHcaptchaElements = jQuery(".h-captcha, .nf-h-captcha");

                if (allHcaptchaElements.length === 0) {
                    setTimeout(function() {
                        window.nfRenderHcaptcha();
                    }, 200);
                    return;
                }
                
                jQuery(".h-captcha, .nf-h-captcha").each(function() {
                    // Check if element is effectively empty (no content or only whitespace)
                    var isEmpty = this.innerHTML.trim() === "";
                    
                    if (!isEmpty) {
                        return; // Skip this element
                    }
                    var element = this;
                    var sitekey = jQuery(element).data("sitekey");
                    var fieldId = jQuery(element).data("fieldid");

                    if (!sitekey) {
                        return;
                    }

                    try {
                        var widgetId = hcaptcha.render(element, {
                            sitekey: sitekey,
                            theme: jQuery(element).data("theme") || "light",
                            size: jQuery(element).data("size") || "normal",
                            callback: function(token) {
                                var fieldID = jQuery(element).data("fieldid");
                                var input = document.getElementById("nf-field-" + fieldID);
                                if (input) {
                                    input.value = token;
                                    jQuery(input).trigger("change");
                                    jQuery(input).closest(".field-wrap").removeClass("nf-error");
                                    jQuery(input).closest(".field-wrap").find(".nf-error-msg").remove();
                                }

                                if (typeof nfRadio !== "undefined" && nfRadio.channel) {
                                    try {
                                        nfRadio.channel("hcaptcha").request("update:response", token, fieldID);
                                    } catch(e) {}
                                }
                            }
                        });
                    } catch(e) {
                        console.error('hCaptcha render error:', e);
                    }
                });
            };
        },

        bindHcaptchaEvents: function() {
            var self = this;
            
            // Initial render attempt
            if (typeof window.nfRenderHcaptcha === "function") {
                window.nfRenderHcaptcha();
            }

            // Bind to document ready
            jQuery(document).ready(function() {
                setTimeout(window.nfRenderHcaptcha, 100);
            });

            // Bind to Ninja Forms events
            jQuery(document).on("nfFormReady", function() {
                setTimeout(window.nfRenderHcaptcha, 100);
            });

            if (typeof nfRadio !== "undefined") {
                try {
                    nfRadio.channel("form").on("render:view", function() {
                        setTimeout(window.nfRenderHcaptcha, 100);
                    });
                } catch(e) {}
            }

            // Retry mechanism for delayed element appearance
            var retryCount = 0;
            var maxRetries = 10;
            var retryInterval = setInterval(function() {
                retryCount++;
                if (retryCount >= maxRetries) {
                    clearInterval(retryInterval);
                    return;
                }

                if (jQuery(".h-captcha, .nf-h-captcha").length > 0) {
                    window.nfRenderHcaptcha();
                    clearInterval(retryInterval);
                }
            }, 500);
        }
    });

    return controller;
} );
